const READ = 'read';
const UPDATE = 'update';
const EXECUTE = 'execute';
const OWNER = 'owner';

const PERMISSIONS = [
  `user:${READ}`,
  `user:${UPDATE}`,

  `role:${READ}`,
  `role:${UPDATE}`,

  `connection:${READ}`,
  `connection:${UPDATE}`,

  `prompt-chain:${READ}`,
  `prompt-chain:${UPDATE}`,
  `prompt-chain:${EXECUTE}`,
  `prompt-chain:${OWNER}`,

  `api-user:${READ}`,
  `api-user:${UPDATE}`,

  `user-action-logs:${READ}`
] as const;

const PROMPT_CHAIN_PERMISSIONS = PERMISSIONS.filter((permission) =>
  permission.startsWith('prompt-chain:')
);
const PERMISSION = Object.fromEntries(PERMISSIONS.map((value) => [value, value])) as {
  readonly [K in (typeof PERMISSIONS)[number]]: K;
};

const FLOW_PERMISSIONS = [...PERMISSIONS, `prompt-chain:${OWNER}`] as const;

const FLOW_PERMISSION = Object.fromEntries(FLOW_PERMISSIONS.map((value) => [value, value])) as {
  readonly [K in (typeof PERMISSIONS)[number]]: K;
};

const PERMISSION_DEPENDENCIES = [
  {
    requires: [`user:${UPDATE}`],
    target: `user:${READ}`
  },
  {
    requires: [`role:${UPDATE}`],
    target: `role:${READ}`
  },
  {
    requires: [`connection:${UPDATE}`],
    target: `connection:${READ}`
  },
  {
    requires: [`prompt-chain:${UPDATE}`, `prompt-chain:${EXECUTE}`],
    target: `prompt-chain:${READ}`
  },
  {
    requires: [`api-user:${UPDATE}`],
    target: `api-user:${READ}`
  },
  {
    requires: [`prompt-chain:${OWNER}`],
    target: `prompt-chain:${UPDATE}`
  },
  {
    requires: [`prompt-chain:${OWNER}`],
    target: `prompt-chain:${EXECUTE}`
  }
] as const;

export {
  READ,
  UPDATE,
  EXECUTE,
  OWNER,
  PERMISSIONS,
  PERMISSION,
  FLOW_PERMISSION,
  FLOW_PERMISSIONS,
  PERMISSION_DEPENDENCIES,
  PROMPT_CHAIN_PERMISSIONS
};
